export type ScanStatus = 'pending' | 'clean' | 'threat' | 'error';

const NOT_CLEAN: ScanStatus[] = ['pending', 'threat', 'error'];

export const scanStatusOf = (...values: unknown[]): ScanStatus => {
  const value = values.find(
    (item) => item !== undefined && item !== null && item !== '',
  );
  return NOT_CLEAN.includes(value as ScanStatus)
    ? (value as ScanStatus)
    : 'clean';
};

export const isScanClean = (...values: unknown[]) =>
  scanStatusOf(...values) === 'clean';

export const scanStatusLabels: Record<ScanStatus, string> = {
  pending: 'Scanning for malware…',
  clean: 'Scanned',
  threat: 'Flagged by malware scanning',
  error: 'Scan failed',
};

export const sourceScanStatusLabels: Record<ScanStatus, string> = {
  pending: 'Source scanning for malware…',
  clean: 'Source scanned',
  threat: 'Source flagged by malware scanning',
  error: 'Source scan failed',
};
